import { useEffect, useState } from 'react';

interface LottieLoaderProps {
  size?: number;
  className?: string;
}

export function LottieLoader({ size = 200, className = '' }: LottieLoaderProps) {
  const [LottieComponent, setLottieComponent] = useState<any>(null);
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    // Lazy-load both Lottie library and animation data in parallel
    Promise.all([
      import('lottie-react'),
      fetch('https://lottie.host/3dc6d0a3-fe5c-48a4-9790-4ea62283a307/sX2bBrD0vU.json').then(r => r.json()),
    ])
      .then(([lottieModule, data]) => {
        setLottieComponent(() => lottieModule.default);
        setAnimationData(data);
      })
      .catch(() => {
        // Fallback stays as CSS spinner
      });
  }, []);

  return (
    <div className={`flex items-center justify-center min-h-screen ${className}`}>
      {LottieComponent && animationData ? (
        <div className="animate-fade-in">
          <LottieComponent
            animationData={animationData}
            loop={true}
            style={{ width: size, height: size }}
          />
        </div>
      ) : (
        // Inline CSS spinner — renders instantly, no external dependencies
        <div className="animate-spin rounded-full h-12 w-12 border-3 border-primary/20 border-t-primary" />
      )}
    </div>
  );
}
